import "./style.scss";
import {
  TextField,
  Typography,
  List,
  ListItem,
  InputAdornment,
  Fab,
  Autocomplete,
  Box,
} from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { ToastContainer, toast, Zoom } from "react-toastify";
import Loading from "../../../ui-components/Loding/Loading";
import { ls } from "../../../utils/localStorage";
import SaveIcon from "@mui/icons-material/Save";
import { Formik } from "formik";
import { getPreferenceData, updatePreferenceData } from "../../../api/api";
import CustomSlider from "../../CustomSlider";
import { religionsList } from "../../../utils/dropDownValues";

const SearchableDropdown = ({
  name,
  label,
  options,
  value,
  onChange,
  onBlur,
  getOptionLabel = (option) => option?.name || "",
  disabled = false,
  noOptionsText = "No options",
}) => {
  return (
    <Autocomplete
      size="small"
      fullWidth
      options={options || []}
      value={value || null}
      onChange={(_, selectedValue) => onChange(selectedValue)}
      onBlur={onBlur}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, selected) =>
        String(option?.id) === String(selected?.id)
      }
      disabled={disabled}
      noOptionsText={noOptionsText}
      renderInput={(params) => (
        <TextField {...params} name={name} label={label} />
      )}
    />
  );
};

const EditPreferences = () => {
  const [loading, setLoading] = useState(true);
  const [dropdownOptions, setDropdownOptions] = useState(null);
  const [states, setStates] = useState(null);
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [enableSaveButton, setEnableSaveButton] = useState(false);

  const [formData, setFormData] = useState({
    age: [],
    annual_income: "",
    caste: "",
    country: "",
    district: "",
    dosham: "",
    drinking_habits: "",
    eating_habits: "",
    education: "",
    employed_in: "",
    height: [],
    location: "",
    looking_for: "Homely girl",
    marital_status: "",
    mother_tongue: "",
    occupation: "",
    physical_status: "",
    religion: "",
    smoking_habits: "",
    star: "",
    state: "",
    zodiac: "",
  });

  const fetchDropdownsValues = async () => {
    const data = JSON.parse(ls.getItem("dropdown_values_for_reference"));
    setDropdownOptions(data);
    fetchPreferenceData();
  };

  const fetchStates = async () => {
    const data = JSON.parse(ls.getItem("states_for_reference"));
    setStates(data);
    fetchPreferenceData(data);
  };

  useEffect(() => {
    fetchDropdownsValues();
    fetchStates();
    fetchPreferenceData();
  }, []);

  const filterDistrictFromState = (districts, values) => {
    const filteredList = values.state
      ? districts.filter((obj) => values.state === obj.state_id)
      : districts;
    setFilterDistrict([...filteredList]);
  };

  const fetchPreferenceData = async (state) => {
    try {
      setLoading(true);
      const response = await getPreferenceData();

      if (response && response.data) {
        setFormData({
          ...formData,
          ...response.data,
          age: [response?.data?.age?.from, response?.data?.age?.to],

          height: [
            isNaN(response?.data?.height?.from) ? 0 : 120,
            isNaN(response?.data?.height?.to) ? 0 : 150,
          ],
        });
        if (state) filterDistrictFromState(state.DISTRICTS, formData);
        setLoading(false);
        setEnableSaveButton(false);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error?.message || "Something wend wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
      setLoading(false);
    }
  };

  const updatePreference = async (data) => {
    setLoading(true);
    try {
      const response = await updatePreferenceData(data);
      console.log(response, "response");
      if (response.status === 204) {
        toast.success("Profile updated successfully", {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        });
        fetchPreferenceData();
        setLoading(false);
      }
    } catch (error) {
      console.log({ error });
      setLoading(false);
      toast.error(
        error?.response?.data?.error?.message || "Something went wrong.",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
    }
  };

  const getSelectedOptionById = (options, selectedId) => {
    if (selectedId === undefined || selectedId === null || selectedId === "") {
      return null;
    }

    return (
      options?.find((option) => String(option.id) === String(selectedId)) ||
      null
    );
  };

  const handleReset = () => {
    setFormData({
      age: [18, 60],
      annual_income: "",
      caste: "",
      country: "",
      district: "",
      dosham: "",
      drinking_habits: "",
      eating_habits: "",
      education: "",
      employed_in: "",
      height: [120, 150],
      location: "",
      looking_for: "",
      marital_status: "",
      mother_tongue: "",
      occupation: "",
      physical_status: "",
      religion: "",
      smoking_habits: "",
      star: "",
      state: "",
      zodiac: "",
    });
    setEnableSaveButton(true);
  };

  return (
    <div
      className="container-fluid edit-preferences"
      style={{
        overflow: loading ? "hidden" : "auto",
        height: loading ? "calc(100vh - 112px)" : "auto",
      }}
    >
      <div>
        <h1>Edit Preferences</h1>
        <br />
        {dropdownOptions ? (
          <Formik
            enableReinitialize={true}
            initialValues={formData}
            validate={(values) => {
              // if(JSON.stringify(values) === JSON.stringify(formData)){
              //   setEnableSaveButton(false);
              //   }
              //   else {
              setEnableSaveButton(true);
              // }
              const errors = {};
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const data = { ...values };
              console.log(data, formData, "data");
              Object.keys(data).forEach((e) => {
                if (data[e] == null) {
                  data[e] = "";
                }
              });
              let payload = { ...formData, ...data };
              payload.height = {
                from: payload.height[0].toString(),
                to: payload.height[1].toString(),
              };
              payload.age = {
                from: payload.age[0].toString(),
                to: payload.age[1].toString(),
              };
              payload.caste = payload.caste.toString();
              payload.country = payload.country.toString();
              payload.drinking_habits = payload.drinking_habits.toString();
              payload.eating_habits = payload.eating_habits.toString();
              payload.education = payload.education.toString();
              payload.marital_status = payload.marital_status.toString();
              payload.mother_tongue = payload.mother_tongue.toString();
              payload.occupation = payload.occupation.toString();
              payload.physical_status = payload.physical_status.toString();
              payload.religion = payload.religion.toString();
              payload.annual_income = payload.annual_income.toString();
              payload.smoking_habits = payload.smoking_habits.toString();
              payload.star = payload.star.toString();
              payload.zodiac = payload.zodiac.toString();
              payload.state = payload.state.toString();
              payload.district = payload.district.toString();

              delete payload.id;
              delete payload.created_by;
              delete payload.updated_by;
              delete payload.created_at;
              delete payload.updated_at;

              console.log(payload, "payload");
              updatePreference(payload);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
            }) => {
              const casteOptions = values?.religion
                ? (
                    religionsList.find(
                      (option) => String(option.id) === String(values.religion),
                    )?.castes || []
                  ).map((item) => ({ id: item.id, name: item.caste }))
                : [];

              const districtOptions =
                states?.DISTRICTS?.filter(
                  (obj) => String(values.state) === String(obj.state_id),
                ) || [];

              return (
                <form onSubmit={handleSubmit}>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
                  >
                    <Fab
                      type="button"
                      variant="extended"
                      // color="primary"
                      onClick={handleReset}
                    >
                      <SaveIcon /> Reset
                    </Fab>
                    <Fab
                      type="submit"
                      className="save_btn"
                      variant="extended"
                      color="primary"
                      disabled={!enableSaveButton}
                    >
                      <SaveIcon /> Save Preferences
                    </Fab>
                  </Box>

                  <div className="row">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Basic Preference
                        </Typography>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Age (Years):
                            </Typography>
                          </div>
                          <div
                            className="col-sm-6"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <CustomSlider
                              min={18}
                              max={60}
                              marks
                              name="age"
                              value={values.age}
                              onChange={handleChange}
                              valueLabelDisplay="on"
                            />
                          </div>
                        </ListItem>

                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Marital Status:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="marital_status"
                              label="Marital Status"
                              options={dropdownOptions?.MARITAL_STATUS}
                              value={getSelectedOptionById(
                                dropdownOptions?.MARITAL_STATUS,
                                values.marital_status,
                              )}
                              onChange={(selected) =>
                                setFieldValue(
                                  "marital_status",
                                  selected?.id || "",
                                )
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Physical Status:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="physical_status"
                              label="Physical Status"
                              options={dropdownOptions?.PHYSICAL_STATUS}
                              value={getSelectedOptionById(
                                dropdownOptions?.PHYSICAL_STATUS,
                                values.physical_status,
                              )}
                              onChange={(selected) =>
                                setFieldValue(
                                  "physical_status",
                                  selected?.id || "",
                                )
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Smoking Habit:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="smoking_habits"
                              label="Smoking Habit"
                              options={dropdownOptions?.SMOKING}
                              value={getSelectedOptionById(
                                dropdownOptions?.SMOKING,
                                values.smoking_habits,
                              )}
                              onChange={(selected) =>
                                setFieldValue(
                                  "smoking_habits",
                                  selected?.id || "",
                                )
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Height (Feet):
                            </Typography>
                          </div>
                          <div className="col-sm-6" style={{ display: "flex" }}>
                            <CustomSlider
                              min={120}
                              max={220}
                              marks
                              step={1}
                              name="height"
                              value={values.height}
                              onChange={handleChange}
                              valueLabelDisplay="on"
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Mother Tounge:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="mother_tongue"
                              label="Language"
                              options={dropdownOptions?.MOTHER_TOUNGE_LIST}
                              value={getSelectedOptionById(
                                dropdownOptions?.MOTHER_TOUNGE_LIST,
                                values.mother_tongue,
                              )}
                              onChange={(selected) =>
                                setFieldValue(
                                  "mother_tongue",
                                  selected?.id || "",
                                )
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Eating Habit:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="eating_habits"
                              label="Eating Habit"
                              options={dropdownOptions?.FOOD}
                              value={getSelectedOptionById(
                                dropdownOptions?.FOOD,
                                values.eating_habits,
                              )}
                              onChange={(selected) =>
                                setFieldValue(
                                  "eating_habits",
                                  selected?.id || "",
                                )
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Drinking Habit:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="drinking_habits"
                              label="Drinking Habit"
                              options={dropdownOptions?.DRINKING}
                              value={getSelectedOptionById(
                                dropdownOptions?.DRINKING,
                                values.drinking_habits,
                              )}
                              onChange={(selected) =>
                                setFieldValue(
                                  "drinking_habits",
                                  selected?.id || "",
                                )
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Religion Preference
                        </Typography>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Religion:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="religion"
                              label="Religion"
                              options={religionsList}
                              value={getSelectedOptionById(
                                religionsList,
                                values.religion,
                              )}
                              onChange={(selected) => {
                                setFieldValue("religion", selected?.id || "");
                                setFieldValue("caste", "");
                              }}
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Caste:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="caste"
                              label="Caste"
                              options={casteOptions}
                              value={getSelectedOptionById(
                                casteOptions,
                                values.caste,
                              )}
                              onChange={(selected) =>
                                setFieldValue("caste", selected?.id || "")
                              }
                              onBlur={handleBlur}
                              disabled={!values.religion}
                              noOptionsText={
                                values.religion
                                  ? "No matching caste found"
                                  : "Select religion first"
                              }
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Horoscopic Preference
                        </Typography>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Nakshtram:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="star"
                              label="Nakshtram"
                              options={dropdownOptions?.STAR_LIST}
                              value={getSelectedOptionById(
                                dropdownOptions?.STAR_LIST,
                                values.star,
                              )}
                              onChange={(selected) =>
                                setFieldValue("star", selected?.id || "")
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Raasi:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="zodiac"
                              label="Raasi"
                              options={dropdownOptions?.ZODIAC_LIST}
                              value={getSelectedOptionById(
                                dropdownOptions?.ZODIAC_LIST,
                                values.zodiac,
                              )}
                              onChange={(selected) =>
                                setFieldValue("zodiac", selected?.id || "")
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Professional Preference
                        </Typography>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Higher Qualification:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="education"
                              label="Higher Qualification"
                              options={dropdownOptions?.EDUCATION}
                              value={getSelectedOptionById(
                                dropdownOptions?.EDUCATION,
                                values.education,
                              )}
                              onChange={(selected) =>
                                setFieldValue("education", selected?.id || "")
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Employed In:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <TextField
                              name="employed_in"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.employed_in}
                              size="small"
                              fullWidth
                              label="Employed In"
                              variant="outlined"
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Occuption:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="occupation"
                              label="Occupation"
                              options={dropdownOptions?.OCCUPATION}
                              value={getSelectedOptionById(
                                dropdownOptions?.OCCUPATION,
                                values.occupation,
                              )}
                              onChange={(selected) =>
                                setFieldValue("occupation", selected?.id || "")
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Annual Income:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="annual_income"
                              label="Annual Income"
                              options={dropdownOptions?.SALARY}
                              value={getSelectedOptionById(
                                dropdownOptions?.SALARY,
                                values.annual_income,
                              )}
                              onChange={(selected) =>
                                setFieldValue(
                                  "annual_income",
                                  selected?.id || "",
                                )
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Location Preference
                        </Typography>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              Country:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="country"
                              label="Country"
                              options={dropdownOptions?.COUNTRYS}
                              value={getSelectedOptionById(
                                dropdownOptions?.COUNTRYS,
                                values.country,
                              )}
                              onChange={(selected) =>
                                setFieldValue("country", selected?.id || "")
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              State:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="state"
                              label="State"
                              options={states?.STATES}
                              value={getSelectedOptionById(
                                states?.STATES,
                                values.state,
                              )}
                              onChange={(selected) => {
                                setFieldValue("state", selected?.id || "");
                                setFieldValue("district", "");
                              }}
                              onBlur={handleBlur}
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                    <div className="col-sm-6">
                      <List>
                        <ListItem className="row">
                          <div className="col-sm-4">
                            <Typography
                              variant="subtitle1"
                              color="text.secondary"
                              component="div"
                            >
                              District:
                            </Typography>
                          </div>
                          <div className="col-sm-6">
                            <SearchableDropdown
                              name="district"
                              label="District"
                              options={districtOptions}
                              value={getSelectedOptionById(
                                districtOptions,
                                values.district,
                              )}
                              onChange={(selected) =>
                                setFieldValue("district", selected?.id || "")
                              }
                              onBlur={handleBlur}
                              disabled={!values.state}
                              noOptionsText={
                                values.state
                                  ? "No matching district found"
                                  : "Select state first"
                              }
                            />
                          </div>
                        </ListItem>
                      </List>
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        ) : (
          ""
        )}
      </div>
      <Loading
        styles={{ top: 0, left: 0, right: 0, width: "100%" }}
        loading={loading}
      />
      <ToastContainer />
    </div>
  );
};
export default EditPreferences;
